require.config({
  paths: {
    jquery: 'jquery.min',
    jsrender: 'jsrender.min',
    moment: 'moment.min'
  },
  shim: {
    jsrender: ['jquery']
  }
});

define(['jquery', 'jsrender', 'moment'], function($, $jsr, moment) {

  /* ===== XJ-Storage クラス ===== */
  var XJStorage;
  return XJStorage = (function() {

    /* コンストラクタ */
    function XJStorage() {
      var xj;
      xj = this;

      /* バージョン */
      this.version = '1.0.2';

      /* APIのドメイン */
      this.domain = 'www.xj-storage.jp';

      /* 企業コード */
      this.company = '79210';

      /* 期の起算年月日（YYYY/MM/DD） */
      this.firstDate = '1966/05/31';

      /* 期の初期値 */
      this.firstPeriod = 28;

      /* 資料コードのグループ定義 */
      this.groupCode = {};

      /* ニュースリリースのラベル定義 */
      this.groupLabel = {};

      /* jsRender のコンバータ設定 */
      $.views.converters({

        /*
          文字列を指定文字列で指定桁数で埋める
          {fill:val length='(:number)' str='(:string)'}
         */
        fill: function(val) {
          return xj.fill(val, this.tagCtx.props.length, this.tagCtx.props.str);
        },

        /*
          日付情報を書式に変換
          {date:val format='(:string)'}
         */
        date: function(val) {
          var date, format;
          date = moment(new Date(val));
          format = this.tagCtx.props.format != null ? this.tagCtx.props.format : 'YYYY年M月D日';
          return date.format(format);
        },

        /*
          ファイルサイズを自動的に単位を付けて変換
          {fsize:size}
         */
        fsize: function(size) {
          return xj.fsize(size);
        },

        /*
          資料コードから定義ラベルを取得
          {label:disclosureCode}
         */
        label: function(disclosureCode) {
          var label;
          for (label in xj.groupLabel) {
            if ($.inArray(parseInt(disclosureCode), xj.groupLabel[label].doctype) !== -1) {
              if (this.tagCtx.props.get === 'id') {
                return xj.groupLabel[label].id;
              } else {
                return label;
              }
            }
          }
        },

        /*
          ファイル情報からリンク用のHTMLタグを生成
          {link:files fileType='(XJ-Storage:FileType)' text='(:string)' className='(:string)' unitPrefix='(:string)' unitSuffix='(:string)'}
         */
        link: function(files) {
          var blank, file, j, len, linkClass, page, showPage, size, text, textClass, tmpLinkClass, unit, unitClass, unitPrefix, unitSuffix, url;
          if (this.tagCtx.props.text == null) {
            throw new Error('Invaild "link:text"');
            return false;
          }
          if (files == null) {
            return this.tagCtx.props.text;
          }
          showPage = this.tagCtx.props.showPage != null ? this.tagCtx.props.showPage : true;
          for (j = 0, len = files.length; j < len; j++) {
            file = files[j];
            if (file.type === this.tagCtx.props.fileType) {
              url = encodeURI(file.url);
              blank = file.url.match(/\.(pdf)$/) || !file.url.match(new RegExp('^https?://' + location.hostname + '/')) ? ' target="_blank"' : '';
              tmpLinkClass = [];
              if (this.tagCtx.props.className != null) {
                tmpLinkClass.push(this.tagCtx.props.className);
              }
              if (file.url.match(/\.(pdf)$/)) {
                tmpLinkClass.push('pdf');
              } else if (!file.url.match(new RegExp('^https?://' + location.hostname + '/'))) {
                tmpLinkClass.push('blank');
              }
              linkClass = tmpLinkClass.length !== 0 ? ' class="' + tmpLinkClass.join(' ') + '"' : '';
              textClass = this.tagCtx.props.className != null ? this.tagCtx.props.className + "_text" : 'text';
              unitClass = this.tagCtx.props.className != null ? this.tagCtx.props.className + "_unit" : 'unit';
              text = this.tagCtx.props.text;
              size = xj.fsize(file.size);
              page = showPage && (file.page != null) && parseInt(file.page) !== 0 ? "/" + file.page + "P" : '';
              unitPrefix = this.tagCtx.props.unitPrefix != null ? this.tagCtx.props.unitPrefix : '（';
              unitSuffix = this.tagCtx.props.unitSuffix != null ? this.tagCtx.props.unitSuffix : '）';
              unit = (file.size != null) && parseInt(file.size) !== 0 ? "<span class='" + unitClass + "'>" + unitPrefix + size + page + unitSuffix + "</span>" : '';
              return "<a href='" + url + "'" + linkClass + blank + "><span class='" + textClass + "'>" + text + "</span>" + unit + "</a>";
            }
          }
          throw new Error('Invaild "link:fileType"');
          return false;
        }
      });

      /* jsRender のヘルパ設定 */
      $.views.helpers({

        /*
          指定日時を現在と比較して指定日数を過ぎているか比較し真偽値を返す
          {{~isNew(date, expire)}
         */
        isNew: function(date, expire) {
          var later;
          if (expire == null) {
            expire = 30;
          }
          date = moment(new Date(date));
          later = moment().diff(date, 'days');
          if (later < expire) {
            return true;
          } else {
            return false;
          }
        },

        /*
          ファイル情報から指定のパラメータを取得
          {{~finfo(files, fileType, get)}}
         */
        finfo: function(files, fileType, get) {
          var file, j, len;
          for (j = 0, len = files.length; j < len; j++) {
            file = files[j];
            if (file.type === fileType) {
              switch (get) {
                case 'url':
                  return encodeURI(file.url);
                case 'size':
                  return xj.fsize(file.size);
                case 'page':
                  return file.page;
                case 'mark':
                  if (file.url.match(/\.(pdf)$/)) {
                    return 'pdf';
                  } else if (!file.url.match(new RegExp('^https?://' + location.hostname + '/'))) {
                    return 'blank';
                  }
                  return false;
                default:
                  throw new Error('Invaild "finfo:get"');
                  return false;
              }
            }
          }
          throw new Error('Invaild "finfo:fileType"');
          return false;
        }
      });
    }


    /* メソッド： ファイルサイズを自動的に単位を付けて変換 */

    XJStorage.prototype.fsize = function(size) {
      var i, idx, j, ref, unit;
      unit = ['Byte', 'KB', 'MB', 'GB'];
      idx = 0;
      for (i = j = 1, ref = unit.length; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
        if (size < 1024) {
          break;
        }
        size = size / 1024;
        idx = i;
      }
      size = idx >= 2 ? Math.round(size * 10) / 10 : Math.round(size);
      if (size === 0) {
        return '';
      } else {
        return size + unit[idx];
      }
    };


    /* メソッド： XJ-Storage の正常返却フォーマットに統一 */

    XJStorage.prototype.checkData = function(data) {
      var getData;
      getData = {
        items: [],
        length: 0
      };
      if ((data != null) && data.items instanceof Array) {
        getData = data;
      }
      return getData;
    };


    /* メソッド： XJ-Storage API に問い合わせて jqXHR を返す */

    XJStorage.prototype.getList = function(options) {
      var $res, arrayUnique, xj;
      xj = this;
      arrayUnique = function(array) {
        var i, j, ref, storage, uniqueArray, value;
        storage = {};
        uniqueArray = [];
        for (i = j = 0, ref = array.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
          value = array[i];
          if (storage[value] == null) {
            storage[value] = true;
            uniqueArray.push(value);
          }
        }
        return uniqueArray;
      };
      if ((options.doctype != null) && options.doctype instanceof Array) {
        options.doctype = arrayUnique(options.doctype).join(',');
      }
      if ((options.category != null) && options.category instanceof Array) {
        options.category = arrayUnique(options.category).join(',');
      }
      options = $.extend(true, {
        doctype: null,
        fileType: null,
        category: null,
        fdate: null,
        pdate: null,
        len: 10000,
        browser: null,
        browserType: null
      }, options, {
        company: xj.company,
        output: 'json'
      });
      $res = $.ajax({
        url: '//' + xj.domain + '/public-list/GetList.aspx',
        type: 'GET',
        cache: false,
        dataType: 'jsonp',
        data: options
      });
      return $res;
    };


    /* メソッド： XJ-Storage API に問い合わせて返却された JSON を jsRender に渡して処理を行う */

    XJStorage.prototype.render = function(target, template, options) {
      var $res, xj;
      xj = this;
      $res = xj.getList(options);
      $res.done(function(data, statusText, jqXHR) {
        data = xj.checkData(data);
        $('#' + target).html($('#' + template).render(data));
      }).fail(function(jqXHR, statusText, errorThrown) {
        throw new Error('通信に失敗しました -' + statusText + '-' + errorThrown);
      });
    };


    /* メソッド： XJ-Storage API 問い合わせ結果を指定期間で分割する */

    XJStorage.prototype.splitDataInterval = function(data, target, month, day) {
      var item, j, k, key, len, len1, pubdate, ref, splitData, splitKey, val;
      if (target == null) {
        target = 'year';
      }
      if (month == null) {
        month = 1;
      }
      if (day == null) {
        day = 1;
      }
      splitData = {};
      data = this.checkData(data);
      ref = data.items;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        pubdate = moment(new Date(item.publishDate)).add(month - 1, 'months').add(day - 1, 'days');
        switch (target) {
          case 'period':
            splitKey = this.convertDateFormat(item.title, pubdate.format('YYYY/MM/DD')).period;
            break;
          case 'jp':
            splitKey = this.convertDateFormat(item.title, pubdate.format('YYYY/MM/DD')).jp;
            break;
          case 'ad':
            splitKey = this.convertDateFormat(item.title, pubdate.format('YYYY/MM/DD')).ad;
            break;
          default:
            splitKey = pubdate.year();
        }
        if (splitData[splitKey] == null) {
          splitData[splitKey] = {
            items: [],
            length: 0
          };
        }
        splitData[splitKey].items.push(item);
        splitData[splitKey].length++;
      }
      for (val = k = 0, len1 = splitData.length; k < len1; val = ++k) {
        key = splitData[val];
        splitData[key] = this.checkData(val);
      }
      return splitData;
    };


    /* メソッド： XJ-Storage API 問い合わせ結果を先頭から指定件数のみ取得する */

    XJStorage.prototype.shiftData = function(data, length) {
      var shiftData;
      if (length == null) {
        length = 20;
      }
      data = this.checkData(data);
      shiftData = data.items.slice(0, length);
      return {
        items: shiftData,
        length: shiftData.length
      };
    };


    /* メソッド： XJ-Storage API 問い合わせ結果を指定資料コードのみ取得する */

    XJStorage.prototype.filterData = function(data, doctype) {
      var filterData, item, j, len, ref;
      data = this.checkData(data);
      filterData = [];
      ref = data.items;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        if ($.inArray(parseInt(item.disclosureCode), doctype) !== -1) {
          filterData.push(item);
        }
      }
      return {
        items: filterData,
        length: filterData.length
      };
    };


    /* メソッド： 期数表記の相互変換 */

    XJStorage.prototype.convertDateFormat = function(val, date) {
      var checkDate, era, firstDate, firstPeriod, jpera, key, y, year;
      era = {
        '平成': 1988,
        '昭和': 1925,
        '大正': 1911,
        '明治': 1867
      };
      firstDate = moment(new Date(this.firstDate));
      firstPeriod = this.firstPeriod;
      if (!firstDate.isValid()) {
        throw new Error('Invaild "XJStorage.firstDate"');
      }
      checkDate = moment(new Date(val));
      if (val.match(/^\d{4}\/\d{2}\/\d{2}$/ && checkDate.isValid())) {
        if (firstDate > checkDate) {
          throw new Error('Invaild "convertDateFormat more than XJStorage.firstDate "');
        }
      } else {

        /* 全角英数を半角に変換 */
        val = val.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        if (val.match(/(\d+)期/)) {

          /* 期数表記を日付情報に変換 */
          if (parseInt(RegExp.$1) < firstPeriod) {
            throw new Error('Invaild "convertDateFormat less than XJStorage.firstPeriod"');
          } else {
            checkDate = firstDate.clone().add(parseInt(RegExp.$1) - 1 - firstPeriod, 'years');
          }
        } else if (val.match(/(明治|大正|昭和|平成)(\d+)年\d+月期/)) {

          /* 和暦表記を日付情報に変換 */
          checkDate = firstDate.clone().year(parseInt(era[RegExp.$1]) + parseInt(RegExp.$2));
        } else if (val.match(/(\d{4})年\d+月期/)) {

          /* 西暦表記を日付情報に変換 */
          checkDate = firstDate.clone().year(parseInt(RegExp.$1));
        } else if (date != null) {

          /* 書式にマッチしなかったときは第二引数の日付を利用する */
          checkDate = moment(new Date(date));
          if (!checkDate.isValid()) {
            throw new Error('Invaild "convertDateFormat"');
          } else if (firstDate > checkDate) {
            throw new Error('Invaild "convertDateFormat more than XJStorage.firstDate "');
          }
        }
        for (key in era) {
          y = era[key];
          if (checkDate.year() > y) {
            jpera = key;
            break;
          }
        }
      }
      year = checkDate.year();
      return {
        date: checkDate,
        period: '第' + Math.ceil(checkDate.diff(new Date(firstDate.year() + '/01/01'), 'years', true) + firstPeriod) + '期',
        ad: year + '年' + (firstDate.month() + 1) + '月期',
        jp: jpera + parseInt(year - era[jpera]) + '年' + (firstDate.month() + 1) + '月期'
      };
    };

    return XJStorage;

  })();
});
